import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  @Input() idPrefix = '';
  @Input() resetModalStatus = null;
  @Input() supportButton = false;
  @Output() passwordReset = new EventEmitter<any>();

  onPasswordReset(event) {
    this.passwordReset.emit(event);
  }

  ngOnInit() {
  }
}
